module.exports = __webpack_public_path__ + "img/mew-orbit.346649c3.png";